import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  action?: ReactNode;
  variant?: 'info' | 'error' | 'empty';
}

export function StatePanel({
  title,
  description,
  action,
  variant = 'info',
}: Props): JSX.Element {
  const borderColor =
    variant === 'error' ? 'rgba(229, 57, 53, 0.4)' : 'var(--app-border)';
  const titleColor = variant === 'error' ? 'var(--app-error)' : 'var(--app-text-primary)';

  return (
    <Box sx={{ mx: 'auto', maxWidth: 1536, px: 3, py: 6 }}>
      <Stack
        alignItems="center"
        spacing={1.5}
        sx={{
          borderRadius: 'var(--app-radius-container)',
          border: `1px solid ${borderColor}`,
          backgroundColor: 'var(--app-surface)',
          p: 5,
          textAlign: 'center',
          boxShadow: 'var(--app-shadow-card)',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: titleColor }}>
          {title}
        </Typography>
        {description && (
          <Typography
            variant="body2"
            sx={{ color: 'var(--app-text-secondary)', maxWidth: 420, fontSize: 14 }}
          >
            {description}
          </Typography>
        )}
        {action}
      </Stack>
    </Box>
  );
}
